import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { modalActions } from "store-redux/modal-slice";

import NavbarList from "../navbar-list/NavbarList";

import classes from "./SideNavbar.module.css";

const SideNavbar = ({ onClose, onCreateAccount, onSignIn }) => {
  const portalElement = document.getElementById("overlays");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.user);

  const createAccountHandler = () => {
    onClose();
    onCreateAccount();
  };

  const signInHandler = () => {
    onSignIn();
  };

  const navigateAndClose = (path) => {
    onClose();
    navigate(path);
  };

  const depositHandle = () => {
    onClose();
    dispatch(
      modalActions.changeModalComponent({
        modalType: "securityDeposit",
      })
    );
  };

  return createPortal(
    <div className={classes.sideNavbar}>
      <NavbarList isSide onClose={onClose} className={classes.navbarList} />
      {isLoggedIn && (
        <div className={classes.accountActions}>
          <button
            type="button"
            onClick={() => navigateAndClose("/dashboard/transactions?page=1&limit=5")}
          >
            Transactions
          </button>
          <button
            type="button"
            onClick={() => navigateAndClose("/dashboard/wins?page=1&limit=10")}
          >
            My Wins
          </button>
          <button type="button" onClick={depositHandle}>
            Security Deposit
          </button>
        </div>
      )}
      {!isLoggedIn && (
        <div className={classes.authButtons}>
          <button
            type="button"
            className={classes.createAccountButton}
            onClick={createAccountHandler}
          >
            Create an account
          </button>
          <button
            type="button"
            className={classes.signInButton}
            onClick={signInHandler}
          >
            Sign in
          </button>
        </div>
      )}
    </div>,
    portalElement
  );
};

export default SideNavbar;
